export const content = {
  errorsAvailable: 'Die Auswahl enthält Tage mit Fehlern.',
  rescheduleManually: 'Manuell umplanen',
};
